import { Box } from '@material-ui/core';

const EmptyBed = ({ selected = false, popup = false }) => {
  return (
    <Box
      width={popup ? '1.438rem' : '4rem'}
      height={popup ? '2rem' : '4rem'}
      bgcolor={selected ? 'rgba(83, 143, 255, 0.5)' : '#fff'}
      border={selected ? 'solid 1px #538fff' : 'dashed 1px #e4e7eb'}
      borderRadius="4px"
    />
  );
};

export default EmptyBed;
